<template>
  <Spinner v-if="isLoading" />
  <Toast />
        <ConfirmDialog></ConfirmDialog>
        <ConfirmDialog group="templating">
                <template #message="slotProps">
                    <div class="flex p-4">
                        <i :class="slotProps.message.icon" style="font-size: 1.5rem"></i>
                        <p class="pl-2">{{slotProps.message.message}}</p>
                    </div>
                </template>
        </ConfirmDialog>
        <ConfirmDialog group="positionDialog"></ConfirmDialog>
  <div class="grid">    

    <div class="card col-12 helpSection sekcijaTopMargin" v-if="helpVisible">
      <h3>PREGLED POSETE</h3>
      <div class="sekcijaOpis">
        Na ovoj stranici prikazani su svi relevantni podaci o vama i o analizama koje ste odabrali, uključujući ukupnu cenu. Takođe, dostupni su i podaci o statusu analiza i o statusu plaćanja. Mogućnost online plaćanja analiza biće uskoro dostupna, ali trenutno ta opcija još nije aktivirana. Na vrhu stranice nalazi se veliki QR kod, koji treba da pokažete u laboratoriji. Tako osoblje automatski kreira nalog na ime unete osobe i učitava sve odabrane analize. Ovo omogućava i diskreciju, jer nije potrebno objašnjavati koje analize želite obaviti i zašto a i značajno ubrzava postupak prijema.
      </div>

      <div class="sekcijaOpis">
        Ako želite izmeniti spisak analiza, dodati nove analize ili izbrisati neku od već dodatih, možete to učiniti klikom na dugme "Izmenite", koje se nalazi na dnu stranice. Za plaćanje analiza putem interneta, kliknite na dugme "ONLINE PLAĆANJE" (uskoro).
      </div>
      
      <div class="sekcijaOpis">
        Ako želite ponovo da uradite iste analize koje ste ranije već radili, najbolje bi bilo da otvorite zapis o toj prethodnoj poseti i kliknete na dugme "Ponovite analize", koje se nalazi ispod QR koda.
      </div>

      <div class="sekcijaOpis">
        Ukoliko ste greškom sačuvali posetu, možete je obrisati pomoću dugmeta "Brisanje", koje se nalazi na dnu stranice, u levom uglu.
      </div>

    </div>

    <!-- <div class="card col-12 placenoKodovi" v-if="paid">  -->
    <div class="card col-12 placenoKodovi" v-show="status=='Draft'"> 
      <div class="grid codeForLaboratory">
        <div class="headerPlaceholder">
          <div class="col-12 placenotextnaslov" v-if="paid">
            <div>
              {{ translated('analizesuplacene').toUpperCase() }}
            </div>            
            <Button
                @click="helpVisible=!helpVisible"
                icon="pi pi-question"
                :label="ponocString"
                class="helpButton p-button-rounded">
            </Button>   

          </div>
          <div class="col-12 notplacenotextnaslov" v-if="!paid">
            <div>
              {{ translated('analizenisuplacene').toUpperCase() }}
            </div>            
            <Button
                @click="helpVisible=!helpVisible"
                icon="pi pi-question"
                :label="ponocString"
                class="helpButton p-button-rounded">
            </Button>             
          </div>
        </div>
        <div class="col-12 qrcodeplaceholder">          
          <div class="placenotext">{{ translated('popustERROR') }}</div>          
          <div class="placenotext">{{ translated('analitatitle1laboratorija') }}</div>
          <div class="placenotecode">
            <div ref="qrcode" id="qrcodeid"></div>
            <div class="codeUser">{{ codeUser }} - {{ codeAnalysis }}</div>
          </div>
          <div class="placenotextline2">{{ translated('analitatitle2laboratorija') }}</div>
          <div class="sendCodeToMail">            
            <div class="sendcodebutton">
              <Button :label="translated('sendQRmail')" @click="displaSendQRCode=true"></Button>
            </div>
            <div class="sendcodetomaildescription">{{ translated('sendcodetomaildescription') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="card col-12 mainTitle">
      <h3 class="stationsHeader">{{ translated('analysisreview').toUpperCase() }}</h3>   
      <Button :label="translated('duplicateAnalysis')" @click="confirmDuplicate()" icon="pi pi-copy" style="background-color:#0d89ec" class="p-button-raised p-button-secondary p-button-blue buttonDuplicate" />             
    </div>

    <div class="card col-12 mainTitle pdfTitle" v-if="status=='Finished' || status=='InProcess'">
      <h3 class="stationsHeader" v-if="status=='Finished'">Kliknite i preuzmite PDF sa konačnim rezultatima</h3>   
      <h3 class="stationsHeader" v-if="status=='InProcess'">Kliknite i preuzmite PDF sa delomičnim rezultatima</h3>   
      <Button label="PDF" @click="getPdf()" icon="pi pi-file-pdf" style="background-color:#0d89ec" class="p-button-raised p-button-secondary p-button-blue buttonGetPdf" />             
    </div>

    <div class="analysis-elements card col-12 md:col-6">
      <div class="card col-12 mainTitle">
        <!-- <h3 class="stationsHeader">ELEMENTI ANALIZE</h3> -->
        <h3 class="stationsHeader">{{ translated('analysisElements').toUpperCase() }}</h3>
      </div>
      <DataTable class="selectedAnalysisTable" :value="analysisItems" stripedRows tableStyle="width: 100%">
        <Column field="name" header="Naziv">
          <template #body="slotProps">
            {{ formatCurrency(slotProps.data.name) }}
          </template>
        </Column>
        
        <Column field="price" header="Cena">
          <template #body="slotProps">
            {{ formatCurrency(slotProps.data.price) }}
          </template>
        </Column>
      </DataTable>
      <div class="grid totalPriceFrame">
        <div class="col-12 priceTotal">{{ totalPrice }}</div>
        <!-- <div class="totalPrice col-12 grid">
          <div class="col-4 labelTotal">UKUPNO:</div>
          <div class="col-8 priceTotal">{{ totalPrice }}</div>
        </div> -->
      </div>
    </div>

    <div class="analysis-view card col-12 md:col-6">      
      <div class="card col-12 mainTitle">
        <h3 class="stationsHeader">{{ translated('basicInfo').toUpperCase() }}</h3>
      </div>
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('requestedBy') }} </label>
        </div>
        <div class="col-12 sm:col-7">
          <InputText disabled type="text" v-model="ownerPersonFullName"/>
        </div>
      </div>
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('analysisFor') }} </label>
        </div>
        <div class="col-12 sm:col-7">
          <InputText disabled type="text" v-model="analysisPersonFullName"/>
        </div>                         
      </div>
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('requestdate') }} </label>
        </div>
        <div class="col-12 sm:col-7">
          <InputText disabled type="text" v-model="requestDate"/>
        </div>                         
      </div>
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('analysisWithHomeVisit') }} </label>
        </div>
        <div class="col-12 sm:col-7">
          <InputText disabled type="text" v-model="isLinked"/>
        </div>                         
      </div>      
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('status') }} </label>
        </div>
        <div class="col-12 sm:col-7">
          <InputText disabled type="text" v-model="statusName"/>
        </div>                         
      </div>
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('laststatuschange') }} </label>
        </div>
        <div class="col-12 sm:col-7">
            <InputText disabled type="text" v-model="lastStatusChangeDate"/>
        </div>                         
      </div>
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('totalprice') }} </label>
        </div>
        <div class="col-12 sm:col-7">
          <InputText disabled type="text" v-model="totalPrice"/>
        </div>                         
      </div>
      <div class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('paid') }} </label>
        </div>
        <div class="col-12 sm:col-7">
          <InputText disabled type="text" v-model="isPaid"/>
        </div>                         
      </div>
      <div v-if="paid" class="p-fluid grid elementGroup">
        <div class="col-12  sm:col-5 labeldiv">
          <label>{{ translated('paiddate') }} </label>
        </div>
        <div class="col-12 sm:col-7">
          <InputText disabled type="text" v-model="paidDate"/>
        </div>                         
      </div>
    </div>    


    <div class="analysis-view card col-12 priceNotification">      
      
        <label>{{ translated('popustERROR') }}</label>
      
    </div>


    <div class="col-12 buttons" v-if="enabledfield() && !paid">
      <div class="grid">
        <div class="col-6">
          <Button :label="translated('canceling')" @click="confirm()" icon="pi pi-times" style="background-color:#ef1d1d" class="p-button-raised p-button-secondary p-button-red" />  
        </div>        
        <div class="col-6 buttonNew">
          <router-link :to="{ name: 'NewAnalysis', params: { id: id, source: 'review', linked: false, homevisitid: '00000000-0000-0000-0000-000000000000' }}"> 
            <Button :label="translated('editdata')" icon="pi pi-file-edit" style="background-color:#0d89ec" class="p-button-raised p-button-secondary p-button-blue buttonEdit" />
          </router-link>           
        </div>

        <div class="col-12 buttonPay">
          <Button disabled label="USKORO ONLINE PLAĆANJE KARTICAMA!" icon="pi pi-money-bill" style="background-color:#0d89ec" class="p-button-raised p-button-secondary p-button-blue buttonPay" />            
        </div>        
      </div>

    </div>
  </div>

  <Dialog class="modal-sendQRCode" :header="translated('posaljinamail')" v-model:visible="displaSendQRCode" modal :style="{width: '350px'}">

    <div class="grid emailPlaceholder">     
        <input type="text" v-model="emailForQRCode" @keydown="validateEmailOnKey"  :placeholder="translated('unesiemail')" :class="{'errorEmail': !isValidEmail}"  class="col-12" />
    </div>

    <template #footer>        
        <Button :label="translated('send')" icon="pi pi-check" @click="sendQRCode" class="btnSave" />
        <Button :label="translated('cancel')" icon="pi pi-times" @click="displaSendQRCode=false" autofocus class="btnCancel" />
    </template>
  </Dialog>

</template>

<script>
import createHttp from "@/services/http";
import { computed, onBeforeMount } from "vue"
import store from "@/store";
import Spinner from "@/components/Spinner.vue"
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ConfirmDialog from 'primevue/confirmdialog';
import router from "@/router";
import QRCode from 'qrcodejs2';

export default {
  components: { Spinner, DataTable, Column, ConfirmDialog },
  props: ['id'],
  data() {
    return {
        analysisrequest:null,
        translated: computed(() => store.getters.getTranslate),
        ownerPersonFullName:null,
        analysisPersonFullName:null,
        analysisPersonEmail:null,
        isPaid: null,
        paid: null,
        translatedIsPaid: null,  
        totalPrice: null,
        totalPriceNumber: 0,
        lastStatusChangeDate: null,
        statusName: null,
        status: null,
        requestDate: null,
        analysisItems: [],
        paidDate: null,
        isLoading: false,
        isLinked: null,
        codeUser: null,
        codeAnalysis: null,
        codeUsed: null,
        codeDateUsed: null,
        helpVisible: false,
        displaSendQRCode: false,
        emailForQRCode:"",
        errorEmail: false
    }
  }, 
  async created() {
    debugger;
    this.isLoading = true;
    const http = createHttp(true);
    // console.log(this.id +"////////////////////////////////////////////////////////////////////////////////////////////"); 
    const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetAnalysisRequest" + "?id=" + this.id);

        if(result.status==200){
          this.analysisPersonEmail = result.data.analysisPerson.email;
          this.emailForQRCode = result.data.analysisPerson.email;
          this.analysisrequest = result.data;
          this.ownerPersonFullName = this.analysisrequest.ownerPerson.name + ' ' + this.analysisrequest.ownerPerson.surname;
          this.analysisPersonFullName = this.analysisrequest.analysisPerson.name + ' ' + this.analysisrequest.analysisPerson.surname;
          this.isPaid = this.translated('paid_' + this.analysisrequest.paid);
          this.paid = this.analysisrequest.paid;
          this.totalPrice = this.formatCurrency(this.analysisrequest.totalPrice);
          this.totalPriceNumber = this.analysisrequest.totalPrice,
          this.lastStatusChangeDate = this.formatDateTime(this.analysisrequest.lastStatusChange);
          this.statusName = this.translated('analysisStatus_' + this.analysisrequest.status);
          this.status = this.analysisrequest.status;
          this.requestDate = this.formatDateTime(this.analysisrequest.requestDate);
          this.paidDate = this.formatDate(this.analysisrequest.paidDate);
          this.analysisItems = this.analysisrequest.analysisItems;
          this.isLinked = this.formatBoolean(this.analysisrequest.linked);

          this.codeUser = this.analysisrequest.codeUser;
          this.codeAnalysis = this.analysisrequest.codeAnalysis;
          this.codeUsed = this.analysisrequest.codeUsed;
          this.codeDateUsed = this.analysisrequest.codeDateUsed;
          
          this.generateQR();
        }
        this.isLoading = false;
    
  },     
  // async mounted() {
  //   debugger;
    
  // },
  computed: {
    isValidEmail() {
      return /^[^@]+@\w+(\.\w+)+\w$/.test(this.emailForQRCode);
    },
    ponocString() {
        return this.translated('translatedHelp');
    },    
  },
  methods: {
    async fetchPDFByteArray() {
      // console.log('ID ANALIZE: ',this.id);
      const http = createHttp(true); 
      const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetPdf?id=" + this.id, { responseType: 'blob' });

      if(result.status==200){
        // console.log('PDF DATA: ',result.data);
        const pdfData = result.data
        return pdfData;
      } else {
        return null
      }
    },
    async getPdf(){
      debugger;
      const byteArray = await this.fetchPDFByteArray();

      if(byteArray != null && byteArray.size > 0) {
        //const blob = new Blob([byteArray], { type: 'application/pdf' });
        // const url = URL.createObjectURL(byteArray);

        const blobUrl = URL.createObjectURL(byteArray);

        // Create a link element
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', 'BiomedicaRezultati.pdf');

        // Append link to the body
        document.body.appendChild(link);

        // Force click the link to start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);

        // Optional: Revoke the blob URL to free up resources
        URL.revokeObjectURL(blobUrl);


        // window.open(url, '_blank');
      } else {
        // Javim, da ni našel PDF-ja !!!
      }
    },
    async sendQRCode() {
      // Preverim če je pravi e-mail. Če ni pravi email potem e-mail obarvam rdeče.
      if(!this.isValidEmail) {
        this.errorEmail = true;
        return;
      }

      debugger;
      this.isLoading = true;

      const http = createHttp(true); 
      try {                
          http.post(process.env.VUE_APP_API_FOLDER + "/SendQRCodeToEmail?emailDestination=" + this.emailForQRCode + "&id=" + this.id)
              .then((response) => {                   
                this.isLoading = false;
                this.displaSendQRCode=false;
              })
              .catch((error) => {
                this.isLoading = false;
              });

      } catch (error) {
          // console.log(error);
          this.isLoading = false;
      }
    },
    async duplicate(event) {
      // TODO: Prvo treba da se prikaže modal dialog gde čemo da pitamo, dal stvarno želi da uradi duplikat. Ako kaše DA onda uradimo što piše dalje ako ne onda samo zatvorimo dialog i to je to.
      // Zovi server, na serveru se napravi duplikaz, i onda nazad dobiješ ID od duplikata i onda napraviš redirect na preview sa tim novim ID-jem
    
        debugger;
        // this.isLoading = true;
        localStorage.setItem('selectedAnalize', JSON.stringify(this.analysisItems));
        this.$router.push({ name: 'NewAnalysis', params: { id: this.id , source: 'duplicatedAnalysis', linked: false, homevisitid: '00000000-0000-0000-0000-000000000000' } });
    },
    formatDate(value) {
       let myDate = new Date(value); ;

       return myDate.toLocaleDateString('ro-Ro');
    },
    formatDateTime(value) {
      

      const dateParts = value.split("T");

      const date = dateParts[0];
      const time = dateParts[1];

      const formattedDate = date.split("-").reverse().join(".");

      const formattedDateTime = `${formattedDate} ${time}`;

      return formattedDateTime;
    },
    formatCurrency(amount){
      const formattedAmount = amount.toLocaleString('rs-RS', {
        style: 'currency',
        currency: 'RSD',
      });
      return formattedAmount.replace(/(^\D*)([\d,.]*)(\D*$)/, "$2 $1").trim();
      // return formattedAmount.replace(/(^\D*)(\d.*\d)(\D*$)/, '$2 $1').trim();
    },
    confirm(event) {            
        // console.log('confirm');
        this.$confirm.require({
            message: this.translated('areYouSureCancelAnalysis'),
            header: this.translated('canceling'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.translated('yes'),
            rejectLabel: this.translated('no'),
            accept: () => {
                // console.log('confirmaccept');
                this.isLoading = true;
                this.deleteAnalysis(event);
            },
            reject: () => {
                // console.log('confirm1reject');
                this.isLoading = true;
                this.$toast.add({severity:'error', summary:'Odbijeno', detail:'Niste otkazali analizu', life: 3000});
                this.isLoading = false;
            }
        });
    },
    confirmDuplicate(event) {            
        // console.log('confirmDuplicate');
        this.$confirm.require({
            message: this.translated('areYouSureConfirmDuplicate'),
            header: this.translated('duplicatingAnalysis'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.translated('yes'),
            rejectLabel: this.translated('no'),
            accept: () => {
                // console.log('confirmDuplicateaccept');
                this.isLoading = true;
                this.duplicate(event);
                this.isLoading = false;
            },
            reject: () => {
                // console.log('confirmDuplicatereject');
                this.isLoading = true;
                this.$toast.add({severity:'error', summary:this.translated('declined'), detail:this.translated('youDidNotDuplicateAnalysis'), life: 3000});
                this.isLoading = false;
            }
        });
    },
    async deleteAnalysis(event)  {

      this.isLoading = true;

      const http = createHttp(true); 
      try {                
          http.delete(process.env.VUE_APP_API_FOLDER + "/deleteAnalysisRequest" + "?id=" + this.id)
              .then((response) => { 
                  // console.log('OK RESPONSE');
                  // console.log(response);
                  this.$toast.add({severity:'info', summary:'Potvrđeno', detail:'Otkazali ste analizu', life: 3000});

                  // console.log('TAST MESSAGE PRE TOGA');
                  // console.log('OK response');
                  // console.log(response);
                  setTimeout(() => {
                      router.push("/");
                  }, 3000);
              })
              .catch((error) => {
                  const myErr = {...error};

                  // console.log('ERROR');
                  // console.log(myErr);                                            
              });

      } catch (error) {
          // console.log(error);
          this.isLoading = false;
      }

    },
    enabledfield(){
      debugger;
      if(this.status != "NotStarted" && this.status != "Draft"){
        return false;
      }
      return true;
    },
    formatBoolean(value){
      debugger;
      return this.translated(value ? 'yes' : 'no');
      // return value ? 'DA' : 'NE';
    },
    generateQR() {

      debugger;
      if (this.$refs.qrcode) {
        this.$refs.qrcode.innerHTML = '';

        new QRCode(this.$refs.qrcode, {
          text: this.codeUser + '-' + this.codeAnalysis,
          width: 128,
          height: 128
        });
      }
      // Clear previous QR code if present


      // Create a new QR code

    }       
  }  
}
</script>

<style scoped>
.labeldiv { padding-bottom:0px}
.elementGroup { margin-bottom: 10px}
.pricelist{ list-style: none; }
.submitbtn{
  width:200px;
  position: absolute;
  font-size: large;
  font-weight: bolder;
  margin-left: 1%;
}
input.p-inputtext.p-component.p-filled.col-offset-2.col-4 {
    text-align: center;
    color: #c40e19;
    font-weight: bold;
    text-align: end;
}
/* .totalPriceFrame{
  border-top: black 2px solid;
} */
/* .buttons{
  display: flex;
  justify-content: space-between;
} */

/deep/ .p-datatable .p-datatable-tbody > tr > td:nth-child(2)  { text-align:right; }

/deep/ .p-datatable .p-datatable-thead > tr > th:nth-child(2) div {    
    float:right;
    position:relative;
    display:block;
}

.priceTotal {
    text-align: right;
    font-weight: bold;
    font-size: 1.3em;
    padding-right: 20px;
}

.grid.totalPriceFrame {
    margin-top: 10px;
    border-top: solid 2px darkgrey;
}
/* .buttons{
  display: flex;
  justify-content: flex-end;
}
.buttonPay{
  margin-left: 50px;
}
.buttonEdit{
  margin-left: 500px;
}
@media (max-width: 850px) {
  .buttonPay {
    margin-left: 35px;
  }
  .buttonEdit{
  margin-left: 400px;
}
}
@media (max-width: 450px) {
  .buttonPay {
    margin-left: 35px;
  }
  .buttonEdit{
  margin-left: 40px;
}
}
@media (max-width: 300px) {
  .buttonPay {
    margin-left: 0px;
  }
  .buttonEdit{
  margin-left: 0px;
}
} */


.rightBottnGroup {position: relative;float: right;}
button.buttonPay { margin-left: 30px;}

.mainTitle { display: flex; justify-content: space-between;}

.placenoKodovi { margin-top: 20px; }
.codeUserLabel, .codeAnalizalabel {position:relative; float:left;    font-weight: bold;
    text-decoration: underline;
    text-decoration-color: #c52127;
    text-decoration-style: double;}
.codeAnaliza, .codeUser {position:relative; float:left; padding-left:10px; font-weight:bold; text-decoration:underline;    text-decoration-color: #c52127; text-decoration-style: double; }
.codeForLaboratory { font-size:1.5em;}
.notplacenotextnaslov {background-color: #c52127; color:white; font-size:1.4em; font-weight:bold;border-radius:5px;display: flex;justify-content: space-between;align-items: center;}
.placenotextnaslov {background-color:rgb(34, 185, 41); color:white; font-size:1.4em; font-weight:bold;border-radius:5px;display: flex;justify-content: space-between;align-items: center;}

div#qrcodeid {
    margin-bottom: 20px;
    margin-top: 20px;
}

.qrcodeplaceholder { text-align: center; }
.placenotecode { margin-top: 40px; display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; }
.placenotext {font-weight: bold;margin-bottom: 15px;}
.headerPlaceholder {width: 100%;}

.sendCodeToMail {
    clear: both;
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: center;
    padding: 50px 0 20px 0;
}

.placenotextline2 {clear: both;margin-top: 20px;position: relative;float: left;}

.grid.emailPlaceholder { padding: 30px 0 10px 0; }
.sendcodetomaildescription { margin-top: 10px; }
.card.col-12.mainTitle.pdfTitle { background: #db9a9a8f;}
.card.col-12.mainTitle.pdfTitle h3 { color:black;}
input.errorEmail {background:#c52127;color:white;border-color: #c52127;}

.priceNotification {color: #c52127;}

@media (max-width: 600px) {
  .mainTitle {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  button.buttonDuplicate {
    margin-top: 20px;
  }

  button.buttonGetPdf {
    margin-top: 20px;
  }
}

.buttonNew {display: flex;justify-content: right;}
.buttonPay {display: flex;justify-content: right;}

</style>
